module.exports = __webpack_public_path__ + "img/pengaduan-konsumen.f90876be.jpg";